// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/leaf.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%; 
}

img, svg {
  max-width: 100%;
  height: auto;
  display: block;
}

.title {
  font-size: clamp(2rem, 6vw, 4rem);
  font-weight: bold;
  color: black;
  margin: 0 0 .5rem 0;
  line-height: 1.05;
  word-break: break-word;
}

.subtitle {
  font-size: clamp(1.25rem, 4vw, 2.5rem);
  font-weight: 600;
  color: #555;
  margin-top: 0.25rem;
  line-height: 1.1;
}

.description,
.about-text,
.health-plans-description,
.how-it-works-description,
.plan-description,
.step-description {
  font-size: 1.02rem;
  color: #666;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

.homepage-container,
.about-container,
.how-it-works-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 4rem;
  background-color: white;
}

.text-section,
.image-section,
.about-image-section,
.about-text-box,
.how-it-works-image,
.how-it-works-steps {
  width: 100%;
  min-width: 0; 
}

.diet-image {
  width: 100%;
  max-width: 520px;
  height: auto;
}

.about-text-box {
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #333;
  width: 100%;
  box-shadow: none;
  min-width: 0; 
}

.health-plans-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  align-items: stretch;
}

.health-plan-box {
  width: calc(50% - 20px);
  max-width: 320px;
  margin-bottom: 50px;
}

@media (max-width: 520px) {
  .health-plan-box {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .homepage-container,
  .about-container,
  .how-it-works-content {
    flex-direction: column;
    padding: 1.5rem;
  }

  .homepage-container {
    margin-top: 0;
  }

  .diet-image {
    max-width: 420px;
  }

  .about-image {
    max-width: 220px;
  }

  .about-text-box {
    padding: 1.25rem;
  }

  .whatsapp-button {
    bottom: 15px;
    right: 15px;
    padding: 10px 14px;
    font-size: 0.95rem;
  }

  .how-it-works-steps {
    width: 100%;
  }

  .step {
    align-items: flex-start;
    gap: 0.5rem;
  }

  .step-header {
    gap: 8px;
  }
}

.break-word {
  word-break: break-word;
  overflow-wrap: anywhere;
}

body {
  background-color: white;
}

.homepage-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 4rem;
  margin-top: -40px;
}

.text-section {
  width: 50%;
}

.title {
  font-size: 4rem;
  font-weight: bold;
  color: black;
}

.subtitle {
  font-size: 2.5rem;
  font-weight: 600;
  color: #555;
  margin-top: 0.5rem;
}

.description {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1.5rem;
  line-height: 1.8;
}

.image-section {
  width: 50%;
  display: flex;
  justify-content: flex-end;
}

.diet-image {
  width: 85%;
  max-width: 500px;
}

.about-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4rem;
  background-color: white;
}

.about-image-section {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.about-image {
  width: 100%;
  max-width: 280px;
  border-radius: 10px;
  border: 3px solid #333;
}

.founder-title {
  margin-top: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.founder-name {
  margin-top: 10px;
  font-size: 1.5rem;
  font-weight: bold;
}

.about-text-box {
  width: 65%;
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #333;
}

.about-heading {
  font-size: 2.5rem;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 1rem;
  color: #333;
  text-align: center;
}

.about-text {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.whatsapp-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  background-color: #25d366;
  color: white;
  padding: 12px 20px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.3s ease;
  z-index: 1000;
}

.whatsapp-button:hover {
  background-color: #1ebe5d;
}

.whatsapp-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

.step {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-icon {
  font-size: 24px;
  color: #4CAF50;
}

.step-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  margin-top: 10px;
}

.step-description {
  font-size: 16px;
  line-height: 1.4;
  margin: 5px 0 0 34px; 
}

h3 {
  margin: 0;
}

p {
  margin-top: 5px;
}

@media (max-width: 768px) {
  .homepage-container {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
    margin-top: -20px;
  }

  .text-section {
    width: 100%;
  }

  .image-section {
    width: 100%;
    justify-content: center;
    margin-top: 20px;
  }

  .diet-image {
    width: 100%;
    max-width: 400px;
  }

  .about-container {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }

  .about-image-section {
    width: 100%;
    margin-bottom: 1rem;
  }

  .about-image {
    max-width: 220px;
  }

  .about-text-box {
    width: 100%;
    padding: 1.5rem;
  }

  .whatsapp-button {
    bottom: 15px;
    right: 15px;
    padding: 10px 16px;
    font-size: 0.9rem;
  }

  .whatsapp-icon {
    font-size: 1.3rem;
  }
}

.how-it-works-container {
  padding: 4rem;
  background-color: white;
  text-align: center;
}

.how-it-works-heading {
  font-size: 2.8rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1.5rem;
}

.how-it-works-description {
  font-size: 1.2rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.how-it-works-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
}

.how-it-works-image {
  width: 45%;
}

.consultation-image {
  width: 100%;
  max-width: 450px;
  border-radius: 10px;
}

.how-it-works-steps {
  width: 50%;
  text-align: left;
}

.step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.icon {
  font-size: 2rem;
  margin-right: 15px;
}

.step h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.5rem;
}

.step p {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
}

.health-plans-container {
  background-color: white;
  padding: 50px 20px;
  text-align: center;
}

.health-plans-heading {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.health-plans-description {
  font-size: 1.1rem;
  color: #555;
  max-width: 800px;
  margin: 0 auto 20px;
  line-height: 1.6;
}

.health-plans-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  margin-top: 30px;
}

.health-plan-box {
  background-color: #F0F8E7;
  padding: 20px;
  border-radius: 10px;
  text-align: left;
  width: 280px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.plan-image {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  align-self: center;
}

.plan-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
}

.plan-description {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
  flex-grow: 1;
}

.plan-description p {
  margin-bottom: 10px;
  text-align: left;
}

.plan-description ul {
  list-style: none;
  padding-left: 0;
  margin: 10px 0;
}

.plan-description ul li {
  margin-bottom: 8px;
  padding-left: 5px;
  text-align: left;
}

.plan-description ul li::before {
  content: "• ";
  color: #6B8E23;
  font-weight: bold;
  font-size: 1.2rem;
  margin-right: 5px;
}

@media (max-width: 768px) {
  .how-it-works-container {
    padding: 2rem;
  }

  .how-it-works-content {
    flex-direction: column;
    text-align: center;
  }

  .how-it-works-image {
    width: 100%;
    margin-bottom: 2rem;
    border: 3px solid #333;
  }

  .how-it-works-steps {
    width: 100%;
    text-align: center;
  }

  .step {
    flex-direction: column;
    align-items: center;
  }

  .icon {
    margin-bottom: 10px;
  }
}

.falling-leaves {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
}

.leaf {
  position: absolute;
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  opacity: 0.8;
  animation: fall linear infinite;
}

@keyframes fall {
  0% {
    transform: translateY(-10vh) rotate(0deg);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    transform: translateY(110vh) rotate(360deg);
    opacity: 0;
  }
}

.title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.12rem;
  margin: 0;
  line-height: 1;
}

.word {
  display: inline-block;
  line-height: 1.05;
  word-break: keep-all;
}

.word-diet {
  font-size: clamp(2.4rem, 6vw, 4rem);
  font-weight: 800;
  color: #111;
}

.word-nutrition {
  font-size: clamp(1.9rem, 4.5vw, 2.8rem);
  font-weight: 700;
  color: #333;
}

.word-mindfulness {
  font-size: clamp(1.4rem, 3.5vw, 2rem);
  font-weight: 600;
  color: #444;
  white-space: nowrap; 
  overflow: visible;
}

.subtitle {
  margin-top: 0.4rem;
  font-size: clamp(1rem, 3.2vw, 1.5rem);
  font-weight: 600;
  color: #666;
  text-align: left;
}

@media (max-width: 480px) {
  .title {
    align-items: center;
    text-align: center;
  }

  .word-diet {
    font-size: clamp(5.5rem, 10.1vw, 6.3rem);
  }

  .word-nutrition {
    font-size: clamp(4.5rem, 8.5vw, 5.1rem);
  }

  .word-mindfulness {
    font-size: clamp(3.1rem, 7.5vw, 4.6rem);
    white-space: nowrap; 
    letter-spacing: -0.5px; 
  }

  .subtitle {
    text-align: center;
    font-size: clamp(1.8rem, 5.1vw, 3.1rem);
  }
}

.description-wrapper {
  display: block;
  max-width: 100%;
}

.read-more-hero {
  display: inline-block;
  margin-top: 10px;
  background: transparent;
  border: none;
  color: #004D40;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  font-size: 0.95rem;
}

.read-more-hero:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .description {
    line-height: 1.5;
  }
}

.read-more-about {
  display: none;
  background: transparent;
  border: none;
  color: #004D40;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .read-more-about {
    display: inline-block;
  }
}

@media (min-width: 769px) {
  .about-text {
    white-space: normal !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/HomePage.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yDAA2C;EAC3C,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,uCAAuC;EACzC;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  -webkit-text-size-adjust: 100%; \n}\n\nimg, svg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.title {\n  font-size: clamp(2rem, 6vw, 4rem);\n  font-weight: bold;\n  color: black;\n  margin: 0 0 .5rem 0;\n  line-height: 1.05;\n  word-break: break-word;\n}\n\n.subtitle {\n  font-size: clamp(1.25rem, 4vw, 2.5rem);\n  font-weight: 600;\n  color: #555;\n  margin-top: 0.25rem;\n  line-height: 1.1;\n}\n\n.description,\n.about-text,\n.health-plans-description,\n.how-it-works-description,\n.plan-description,\n.step-description {\n  font-size: 1.02rem;\n  color: #666;\n  line-height: 1.6;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n}\n\n.homepage-container,\n.about-container,\n.how-it-works-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 4rem;\n  background-color: white;\n}\n\n.text-section,\n.image-section,\n.about-image-section,\n.about-text-box,\n.how-it-works-image,\n.how-it-works-steps {\n  width: 100%;\n  min-width: 0; \n}\n\n.diet-image {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n}\n\n.about-text-box {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 10px;\n  border: 2px solid #333;\n  width: 100%;\n  box-shadow: none;\n  min-width: 0; \n}\n\n.health-plans-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 30px;\n  align-items: stretch;\n}\n\n.health-plan-box {\n  width: calc(50% - 20px);\n  max-width: 320px;\n  margin-bottom: 50px;\n}\n\n@media (max-width: 520px) {\n  .health-plan-box {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .homepage-container,\n  .about-container,\n  .how-it-works-content {\n    flex-direction: column;\n    padding: 1.5rem;\n  }\n\n  .homepage-container {\n    margin-top: 0;\n  }\n\n  .diet-image {\n    max-width: 420px;\n  }\n\n  .about-image {\n    max-width: 220px;\n  }\n\n  .about-text-box {\n    padding: 1.25rem;\n  }\n\n  .whatsapp-button {\n    bottom: 15px;\n    right: 15px;\n    padding: 10px 14px;\n    font-size: 0.95rem;\n  }\n\n  .how-it-works-steps {\n    width: 100%;\n  }\n\n  .step {\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .step-header {\n    gap: 8px;\n  }\n}\n\n.break-word {\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\nbody {\n  background-color: white;\n}\n\n.homepage-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n  padding: 4rem;\n  margin-top: -40px;\n}\n\n.text-section {\n  width: 50%;\n}\n\n.title {\n  font-size: 4rem;\n  font-weight: bold;\n  color: black;\n}\n\n.subtitle {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #555;\n  margin-top: 0.5rem;\n}\n\n.description {\n  font-size: 1.2rem;\n  color: #666;\n  margin-top: 1.5rem;\n  line-height: 1.8;\n}\n\n.image-section {\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.diet-image {\n  width: 85%;\n  max-width: 500px;\n}\n\n.about-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4rem;\n  background-color: white;\n}\n\n.about-image-section {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.about-image {\n  width: 100%;\n  max-width: 280px;\n  border-radius: 10px;\n  border: 3px solid #333;\n}\n\n.founder-title {\n  margin-top: 10px;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.founder-name {\n  margin-top: 10px;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.about-text-box {\n  width: 65%;\n  background-color: white;\n  padding: 2rem;\n  border-radius: 10px;\n  border: 2px solid #333;\n}\n\n.about-heading {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 1rem;\n  color: #333;\n  text-align: center;\n}\n\n.about-text {\n  font-size: 1.1rem;\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.whatsapp-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  background-color: #25d366;\n  color: white;\n  padding: 12px 20px;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: background 0.3s ease;\n  z-index: 1000;\n}\n\n.whatsapp-button:hover {\n  background-color: #1ebe5d;\n}\n\n.whatsapp-icon {\n  font-size: 1.5rem;\n  margin-right: 10px;\n}\n\n.step {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n\n.step-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.step-icon {\n  font-size: 24px;\n  color: #4CAF50;\n}\n\n.step-title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 0;\n  margin-top: 10px;\n}\n\n.step-description {\n  font-size: 16px;\n  line-height: 1.4;\n  margin: 5px 0 0 34px; \n}\n\nh3 {\n  margin: 0;\n}\n\np {\n  margin-top: 5px;\n}\n\n@media (max-width: 768px) {\n  .homepage-container {\n    flex-direction: column;\n    text-align: center;\n    padding: 2rem;\n    margin-top: -20px;\n  }\n\n  .text-section {\n    width: 100%;\n  }\n\n  .image-section {\n    width: 100%;\n    justify-content: center;\n    margin-top: 20px;\n  }\n\n  .diet-image {\n    width: 100%;\n    max-width: 400px;\n  }\n\n  .about-container {\n    flex-direction: column;\n    text-align: center;\n    padding: 2rem;\n  }\n\n  .about-image-section {\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .about-image {\n    max-width: 220px;\n  }\n\n  .about-text-box {\n    width: 100%;\n    padding: 1.5rem;\n  }\n\n  .whatsapp-button {\n    bottom: 15px;\n    right: 15px;\n    padding: 10px 16px;\n    font-size: 0.9rem;\n  }\n\n  .whatsapp-icon {\n    font-size: 1.3rem;\n  }\n}\n\n.how-it-works-container {\n  padding: 4rem;\n  background-color: white;\n  text-align: center;\n}\n\n.how-it-works-heading {\n  font-size: 2.8rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 1.5rem;\n}\n\n.how-it-works-description {\n  font-size: 1.2rem;\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.how-it-works-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 3rem;\n}\n\n.how-it-works-image {\n  width: 45%;\n}\n\n.consultation-image {\n  width: 100%;\n  max-width: 450px;\n  border-radius: 10px;\n}\n\n.how-it-works-steps {\n  width: 50%;\n  text-align: left;\n}\n\n.step {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n\n.icon {\n  font-size: 2rem;\n  margin-right: 15px;\n}\n\n.step h3 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.step p {\n  font-size: 1.1rem;\n  color: #555;\n  line-height: 1.6;\n}\n\n.health-plans-container {\n  background-color: white;\n  padding: 50px 20px;\n  text-align: center;\n}\n\n.health-plans-heading {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.health-plans-description {\n  font-size: 1.1rem;\n  color: #555;\n  max-width: 800px;\n  margin: 0 auto 20px;\n  line-height: 1.6;\n}\n\n.health-plans-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: stretch;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.health-plan-box {\n  background-color: #F0F8E7;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: left;\n  width: 280px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.plan-image {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 10px;\n  align-self: center;\n}\n\n.plan-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.plan-description {\n  font-size: 0.95rem;\n  color: #555;\n  line-height: 1.6;\n  flex-grow: 1;\n}\n\n.plan-description p {\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.plan-description ul {\n  list-style: none;\n  padding-left: 0;\n  margin: 10px 0;\n}\n\n.plan-description ul li {\n  margin-bottom: 8px;\n  padding-left: 5px;\n  text-align: left;\n}\n\n.plan-description ul li::before {\n  content: \"• \";\n  color: #6B8E23;\n  font-weight: bold;\n  font-size: 1.2rem;\n  margin-right: 5px;\n}\n\n@media (max-width: 768px) {\n  .how-it-works-container {\n    padding: 2rem;\n  }\n\n  .how-it-works-content {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .how-it-works-image {\n    width: 100%;\n    margin-bottom: 2rem;\n    border: 3px solid #333;\n  }\n\n  .how-it-works-steps {\n    width: 100%;\n    text-align: center;\n  }\n\n  .step {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .icon {\n    margin-bottom: 10px;\n  }\n}\n\n.falling-leaves {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.leaf {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background-image: url('../assets/leaf.png');\n  background-size: cover;\n  opacity: 0.8;\n  animation: fall linear infinite;\n}\n\n@keyframes fall {\n  0% {\n    transform: translateY(-10vh) rotate(0deg);\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(110vh) rotate(360deg);\n    opacity: 0;\n  }\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.12rem;\n  margin: 0;\n  line-height: 1;\n}\n\n.word {\n  display: inline-block;\n  line-height: 1.05;\n  word-break: keep-all;\n}\n\n.word-diet {\n  font-size: clamp(2.4rem, 6vw, 4rem);\n  font-weight: 800;\n  color: #111;\n}\n\n.word-nutrition {\n  font-size: clamp(1.9rem, 4.5vw, 2.8rem);\n  font-weight: 700;\n  color: #333;\n}\n\n.word-mindfulness {\n  font-size: clamp(1.4rem, 3.5vw, 2rem);\n  font-weight: 600;\n  color: #444;\n  white-space: nowrap; \n  overflow: visible;\n}\n\n.subtitle {\n  margin-top: 0.4rem;\n  font-size: clamp(1rem, 3.2vw, 1.5rem);\n  font-weight: 600;\n  color: #666;\n  text-align: left;\n}\n\n@media (max-width: 480px) {\n  .title {\n    align-items: center;\n    text-align: center;\n  }\n\n  .word-diet {\n    font-size: clamp(5.5rem, 10.1vw, 6.3rem);\n  }\n\n  .word-nutrition {\n    font-size: clamp(4.5rem, 8.5vw, 5.1rem);\n  }\n\n  .word-mindfulness {\n    font-size: clamp(3.1rem, 7.5vw, 4.6rem);\n    white-space: nowrap; \n    letter-spacing: -0.5px; \n  }\n\n  .subtitle {\n    text-align: center;\n    font-size: clamp(1.8rem, 5.1vw, 3.1rem);\n  }\n}\n\n.description-wrapper {\n  display: block;\n  max-width: 100%;\n}\n\n.read-more-hero {\n  display: inline-block;\n  margin-top: 10px;\n  background: transparent;\n  border: none;\n  color: #004D40;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.95rem;\n}\n\n.read-more-hero:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 480px) {\n  .description {\n    line-height: 1.5;\n  }\n}\n\n.read-more-about {\n  display: none;\n  background: transparent;\n  border: none;\n  color: #004D40;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 8px;\n}\n\n@media (max-width: 768px) {\n  .read-more-about {\n    display: inline-block;\n  }\n}\n\n@media (min-width: 769px) {\n  .about-text {\n    white-space: normal !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
